export class SubDivision {
  code: string;
  name: string;
  sapSubDivision: string;
}


// WEBPACK FOOTER //
// ./src/app/models/SubDivision.model.ts